export const isMobileSafari = () => navigator.userAgent.toLowerCase().match(/(ipad|iphone)/)

export const redirectToOtherSite = (redirectURL: string, singleTab?: boolean) => {
  const link = document.createElement('a')
  link.href = redirectURL

  //if not safari open in current tab with redirect
  if (!isMobileSafari() && !singleTab) link.target = '_blank'

  link.click()
  link.remove()
}

export const openMail = () => redirectToOtherSite('https://www.gmail.com/')